import BillingSettingsContainer from './BillingSettingsContainer';

export default BillingSettingsContainer;
